import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/n/_auth/settings/_layout/users/$userId/site')({
  beforeLoad: () => {
    throw redirect({ to: '/n/not-found', replace: true });
  },
});
